<template>
  <div class="avatar">
    <div class="avatar-image" :style="{ backgroundImage: `url(${image})` }" />
    <div class="avatar-body">
      <div class="avatar-name">{{ name }}</div>
      <div class="avatar-title" v-if="title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  align-items: center;
  display: flex;
}

.avatar-image {
  background-color: var(--gray);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100px;
  flex-shrink: 0;
  height: 50px;
  margin-right: 12px;
  width: 50px;
}

.avatar-body {
  flex-grow: 1;
  font-size: 18px;
  line-height: 1.2;
}
</style>
